<template>
  <div class="relative w-$portalContainerWidth mx-auto">
    <div
      class="flex h-full bg-hex-$portalPrimaryColor text-hex-$portalPrimaryTextColor  font-400 text-18px w-full"
    >
      <div
        v-for="(item, index) in navList"
        :key="index"
        class="w-1/9 cursor-pointer h-full text-center leading-50px"
      >
        <span
          class="relative"
          @click="navbarClick(item)"
          :class="{
            active: activeName === item.activeName,
          }"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationBarProps',
  data() {
    return {
      currentNav: '',
    }
  },
  props: {
    navList: {
      type: Array,
      default: () => {
        return [
          {
            name: '工作台',
            activeName: 'workbench',
            path: '/integration/portal/workbench',
          },
          {
            name: '通讯录',
            activeName: 'addressBook',
            path: '/integration/portal/addressBook',
          },
          {
            name: '消息',
            activeName: 'message',
            path: '/integration/portal/message',
          },
          // {
          //   name: '资源中心',
          //   activeName: 'sourceCenter',
          //   path: '/integration/portal/source-center',
          // },
        ]
      },
    },
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    activeName() {
      return this.value ? this.value : this.$route.name
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  created() {},
  methods: {
    navbarClick(navbar) {
      if (this.value) {
        this.$emit('input', navbar.activeName)
      } else {
        this.$router.push({
          path: `${this.routerBase}${navbar.path}`,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.active {
  font-weight: 700;
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: var(--portalPrimaryTextColor);
    bottom: -7px;
  }
}
</style>
